import { useEffect, useState } from "react";
import { AuthProvider, useAuth } from "./lib/auth";
import { routeFromHash, type Route } from "./lib/routes";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SavedSearches from "./pages/SavedSearches";
import Settings from "./pages/Settings";
import HotDeals from "./pages/HotDeals";
import Scan from "./pages/lister/Scan";
import CardCapture from "./pages/lister/CardCapture";
import Review from "./pages/lister/Review";
import History from "./pages/lister/History";

function Authed() {
  const [route, setRoute] = useState<Route>(() => routeFromHash(window.location.hash));
  useEffect(() => {
    const onHash = () => setRoute(routeFromHash(window.location.hash));
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  return (
    <Layout page={route.page}>
      {route.page === "dashboard" && <Dashboard />}
      {route.page === "searches" && <SavedSearches />}
      {route.page === "hot-deals" && <HotDeals />}
      {route.page === "settings" && <Settings />}
      {route.page === "lister" && <Scan />}
      {route.page === "lister-card" && <CardCapture />}
      {route.page === "lister-review" && route.sessionId && <Review key={route.sessionId} sessionId={route.sessionId} />}
      {route.page === "lister-history" && <History />}
    </Layout>
  );
}

function Gate() {
  const { state } = useAuth();
  if (state.status === "checking") return <div className="p-6 text-zinc-500 font-mono">…</div>;
  if (state.status === "logged_out") return <Login />;
  return <Authed />;
}

export default function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
